export function BeWomanLogo({ className = "", size = "large" }) {
  const h = size === "large" ? "h-40 sm:h-48" : size === "medium" ? "h-20" : "h-12";
  return (
    <img
      src="/bewoman-logo-v3.png"
      alt="Be Woman"
      data-testid="bewoman-logo"
      className={`${h} w-auto object-contain mx-auto ${className}`}
    />
  );
}
